import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { Store } from '@ngrx/store';

import { updateOrderInStore } from '../../../../../../@store/orders/orders.actions';
import { singleOrderDetails } from '../../../../../../@store/orders/orders.model';
import { SingleCaNumberDetails } from '../../../../../../@store/products/ca-numbers/ca-numbers.model';
import { OrderAddToCaComponent } from '../order-add-to-ca/order-add-to-ca.component';
import { OrderCreateNewCaComponent } from '../order-create-new-ca/order-create-new-ca.component';

@Component({
  selector: 'ciwc-order-custom-job',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButton,
    MatDialogModule,
    NgIf,
  ],
  standalone: true,
  templateUrl: './order-custom-job.component.html',
  styleUrl: './order-custom-job.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderCustomJobComponent implements OnInit, OnChanges {
  @Input() parentForm!: FormGroup;
  @Input() orderDetails!: singleOrderDetails;
  @Input() viewDisable!: boolean;
  @Input() itemProcesses: any[] = [];
  @Input() readonly!: boolean;
  @Output() caNumberSelected = new EventEmitter<SingleCaNumberDetails>();

  constructor(
    private dialog: MatDialog,
    private store: Store,
  ) {}

  ngOnInit(): void {
    this.updateCaNumberDisplay();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['orderDetails']) {
      this.updateCaNumberDisplay();
    }
  }

  private updateCaNumberDisplay(): void {
    // Always update the field to show the current CA number from the backend
    const caNumber = this.orderDetails?.caNumber?.caNumber || '';
    this.parentForm.patchValue({
      caCustomDescription: caNumber,
    });
  }

  openCreateCaModal(): void {
    const dialogRef = this.dialog.open(OrderCreateNewCaComponent, {
      width: '500px',
      data: {
        form: this.parentForm,
        orderId: this.orderDetails.id,
        itemProcesses: this.itemProcesses,
        constructionSteps: this.parentForm.get('constructionSteps')?.value,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // Patch the caNumbersId FormControl in the parent form
        // and update the caCustomDescription with the new CA number
        this.parentForm.patchValue({
          caNumbersId: result.id,
          caCustomDescription: result.caCustomDescription,
        });
      }
    });
  }

  openAddToCaModal() {
    const dialogRef = this.dialog.open(OrderAddToCaComponent, {
      width: '500px',
      data: {
        form: this.parentForm,
        orderId: this.orderDetails.id,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // Emit the CA number details to the parent component
        if (result.details) {
          this.caNumberSelected.emit(result.details);

          // Update the order with the new construction steps in the store
          const updatedOrder: singleOrderDetails = {
            ...this.orderDetails,
            caNumber: result.details,
            constructionSteps: result.details.constructionSteps || [],
          };

          // Dispatch the updateOrderInStore action to update the store without HTTP call
          this.store.dispatch(updateOrderInStore({ order: updatedOrder }));
        }
        // Update the caNumbersId in the parent form
        // and set the caCustomDescription with the CA number
        this.parentForm.patchValue({
          caNumbersId: result.id,
          caCustomDescription: result.details.caNumber,
        });
      }
    });
  }
}
